/* tslint:disable */
/* eslint-disable */
/**
 * external-information-requests
 * Medicaid Pending document requests to family members, with the staff workspace and the family portal
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { StaffMessage } from './StaffMessage';
import {
    StaffMessageFromJSON,
    StaffMessageFromJSONTyped,
    StaffMessageToJSON,
    StaffMessageToJSONTyped,
} from './StaffMessage';

/**
 * 
 * @export
 * @interface StaffMessageResponse
 */
export interface StaffMessageResponse {
    /**
     * 
     */
    data: StaffMessage;
}

/**
 * Check if a given object implements the StaffMessageResponse interface.
 */
export function instanceOfStaffMessageResponse(value: object): value is StaffMessageResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function StaffMessageResponseFromJSON(json: any): StaffMessageResponse {
    return StaffMessageResponseFromJSONTyped(json, false);
}

export function StaffMessageResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): StaffMessageResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': StaffMessageFromJSON(json['data']),
    };
}

export function StaffMessageResponseToJSON(json: any): StaffMessageResponse {
    return StaffMessageResponseToJSONTyped(json, false);
}

export function StaffMessageResponseToJSONTyped(value?: StaffMessageResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': StaffMessageToJSON(value['data']),
    };
}

